import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class LeftVectorToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.LEFT_VECTOR, value );
    }

    toString() {
        return this.value;
    }
}
